import React from "react";
import { handlePauseAllVideo, secondToHour } from "../../../utils";
import Styles from './styles.module.css';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";

export default function VidexBox({ ques, data }) {
    const randomNumber = Math.random()*10;
    const dispatch = useDispatch();
    const {SearchExpDocData} = bindActionCreators(Actions, dispatch)
    const searchState = useSelector(state=>state.search);
    const container = {
        width:'100%',
        display:'flex',
        // alignItems:'baseline',
        justifyContent:'center',
    }
    const videoContainer = {
        width:'75%',
        borderRight:'1.5px solid',
        borderImage:'linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%) 1'
    }
    const stampContainer = {
        width:'23%',
        marginLeft:'2%'
    }
    const ansStyles = {
        // marginTop: "10px",
        fontSize: "16px",
        color: "#2A364A",
        lineHeight: "24px",
        fontWeight: "300",
        marginBottom:'10px',
        // borderBottom:' 1px solid #2A364A'
      };
    const contentStyle = {
        border: "1px solid #E0E2E6",
        borderRadius: "16px",
        boxShadow: "0px 4px 16px 0px #1018280F",
        width:'95%'
      };
      const showMoreStyles = {
        fontSize: "14px",
        color: "#F59B00",
        lineHeight: "20px",
        fontWeight: "500",
        cursor: "pointer",
        marginTop: "5px",
      };
      const showMoreSelectedStyles = {
        fontSize: "12px",
        color: "#5C667B",
        lineHeight: "20px",
        fontWeight: "400",
        background:
          "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
        backgroundClip: "text",
        "-webkit-text-fill-color": "transparent",
        "-moz-text-fill-color": "transparent",
        "-ms-text-fill-color": "transparent",
        "-o-text-fill-color": "transparent",
        cursor: "pointer",
        marginTop: "5px",
      };
      const onClickTimeStamp = (quesId, suggest) => {
        console.log(quesId, suggest, searchState.docData);
        let shallowCopy = [...searchState.docData];
        let quesIndex = shallowCopy.findIndex((ques) => ques.questionUuid === quesId);
        shallowCopy.splice(quesIndex, 1, suggest)
        SearchExpDocData({
            exp:searchState.expertData,
            doc:shallowCopy
          })
          setTimeout(() => {
            document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`).load();
            document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`).play();
            document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`).focus();
          }, 1000);
      }
     
  return (
    <div className="mt-2" style={container} >
      {ques.videoAttachmentURL.length !== 0 && <div style={videoContainer}>
      <video
                 id={`${ques.questionUuid}_${ques.questionUuid}`}
                  controls
                  onBlur={()=>handlePauseAllVideo()}
                  style={contentStyle}
                >
                  <source
                    src={`${ques.videoAttachmentURL[0]}#t=${data.startTime},${data.endTime}`}
                    type="video/mp4"
                  />
                </video>
      </div>}
      <div style={stampContainer}>
        <div style={ansStyles}>Timestamps</div>
        {ques.suggestions.map(suggest=>{
            return(
                <div key={suggest.id} className={Styles.stamp}>
                    <p onClick={()=>onClickTimeStamp(ques.questionUuid, suggest)} style={data.startTime === suggest.answers[0].startTime ?showMoreStyles:showMoreSelectedStyles}>{secondToHour(suggest.answers[0].startTime)}-{secondToHour(suggest.answers[0].endTime)}</p>
                </div>
            )
        })}
      </div>
    </div>
  );
}
